<template>
  <b-overlay
      :show="overlay"
      rounded="sm"
  >

    <div v-if="products !== null">

      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-3"
      >

        <h1 class="m-2">لیست زیرمجموعه های پکیج</h1>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="items"
            responsive
            :fields="myTableItemsColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >
          <template #cell(productId)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                    size="45"
                    :src="`https://api.rahazarei.com/${data.item.imageFile}`"
                    :variant="`success`"
                />
              </template>
              <small class="text-muted">@{{ data.item.productId }}</small>
            </b-media>
          </template>

          <!-- Column: product.price -->
          <template #cell(productPrice)="data">
            <span>{{ makePrettyPrice(data.item.price) }} تومان</span>
          </template>

          <!-- Column: delete -->
          <template #cell(delete)="data">
            <b-link v-b-modal.modal-delete-item @click="deleteItem = data.item.productId">
              <feather-icon icon="TrashIcon" class="text-danger" size="20"/>
            </b-link>
          </template>

        </b-table>
      </b-card>
    </div>

    <div v-if="products !== null">

      <!-- Table Container Card -->
      <b-card
          no-body
          class="mb-3"
      >

        <h1 class="m-2">افزودن محصول</h1>

        <div class="m-2">

          <!-- Table Top -->
          <b-row>
            <!-- Search -->
            <b-col
                cols="12"
                md="10"
            >
              <div class="d-flex align-items-center justify-content-end">
                <b-form-input
                    v-model="searchCommand"
                    class="d-inline-block mr-1"
                    placeholder="جستجو..."
                />
              </div>
            </b-col>

            <b-col
                cols="12"
                md="2"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <label>نمایش</label>
              <v-select
                  v-model="perPage"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="perPageOptions"
                  :clearable="false"
                  class="per-page-selector d-inline-block mx-50"
              />
              <label>تعداد</label>
            </b-col>
          </b-row>
        </div>

        <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="products"
            responsive
            :fields="myTableColumns"
            primary-key="id"
            show-empty
            bordered
            striped
            empty-text="موردی موجود نیست!"
        >
          <template #cell(productId)="data">
            <b-media vertical-align="center">
              <template #aside>
                <b-avatar
                    size="45"
                    :src="`https://api.rahazarei.com/${data.item.imageFile}`"
                    :variant="`success`"
                />
              </template>
              <small class="text-muted">@{{ data.item.productId }}</small>
            </b-media>
          </template>

          <!-- Column: product.price -->
          <template #cell(price)="data">
            <span>{{ makePrettyPrice(data.item.price) }} تومان</span>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-link @click="addItem(data.item.productId)">
              <feather-icon icon="PlusIcon" size="20"/>
            </b-link>
          </template>

        </b-table>
        <div class="mx-2 mb-2">
          <b-row>

            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <!--            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>-->
            </b-col>
            <!-- Pagination -->
            <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >

              <b-pagination
                  v-model="currentPage"
                  :total-rows="totalCounts"
                  :per-page="perPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon style="transform: rotate(180deg)"
                                icon="ChevronLeftIcon"
                                size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                      icon="ChevronRightIcon"
                      size="18"
                  />
                </template>
              </b-pagination>

            </b-col>

          </b-row>
        </div>
      </b-card>
    </div>

    <b-modal
        id="modal-delete-item"
        centered
        ok-title="حذف"
        cancelTitle="انصراف"
        @ok="removeItem()"
    >
      <span>حذف شود؟</span>
    </b-modal>
  </b-overlay>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BMedia, BAvatar, BLink,
  BPagination, BOverlay , BModal
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Helper from "@/libs/Helper";
import {OrderChangeStatusRequest} from "@/libs/Api/Order";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import {OrderDeleteRequest} from "@/libs/Api/Order";
import {OrderGetProductsForStudents} from "@/libs/Api/Order";
import {ProductGetAllRequest} from "@/libs/Api/Product";
import {OrderCreateByAdmin} from "@/libs/Api/Order";
import {
  BundleAddProductBundleRequest,
  BundleGetBundleItemsRequest,
  BundleRemoveProductFromBundleRequest
} from "@/libs/Api/Bundle";

export default {
  title: "لیست محصولات پکیج - پنل ادمین لنزآوا",
  name: "PackageItemsList",
  data() {
    return {
      productId: this.$route.params.id,
      overlay:false,
      products: null,
      currentPage: 1,
      totalCounts: null,
      perPage: 10,
      items:[],
      perPageOptions: [10, 20, 30, 40, 50],
      myTableColumns: [
        {key: 'productId', label: 'شناسه محصول'},
        {key: 'title', label: 'نام محصول'},
        {key: 'price', label: 'قیمت'},
        {key: 'actions', label: 'افزودن به پکیج'},
      ],
      myTableItemsColumns: [
        {key: 'productId', label: 'شناسه محصول'},
        {key: 'title', label: 'نام محصول'},
        {key: 'productPrice', label: 'قیمت'},
        {key: 'delete', label: 'حذف'},
      ],
      searchCommand: '',
      deleteItem:null,
    }
  },
  computed: {
    CartTotal() {
      let result = 0;
      this.Cart.forEach((item) => {
        result += item.amount * item.count
      })
      return result;
    },
    currentDate() {
      let today = new Date();
      let date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
      let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return date + ' ' + time;
    },
  },
  async created() {
    await this.getPackageProducts();
    await this.getProducts(this.perPage, this.currentPage, this.searchCommand);
  },
  methods: {
    refreshData() {
      this.getProducts(this.perPage, this.currentPage, this.searchCommand)
    },
    async getPackageProducts() {
      let _this = this;
      _this.overlay = true;
      let data = {
        bundleId:_this.productId
      }

      let bundleGetBundleItemsRequest = new BundleGetBundleItemsRequest(_this);
      bundleGetBundleItemsRequest.setParams(data)
      await bundleGetBundleItemsRequest.fetch(function (content) {
        _this.items = content.items;
        _this.overlay = false;
      }, function (content) {
        console.log(content)
        _this.overlay = false;
      });
    },
    async getProducts(count, pageNumber, search) {
      let _this = this;
      _this.overlay = true;
      let getProductData = {
        categoryId: 0,
        searchByTitle: search,
        pageNumber: pageNumber,
        count: count,
        type: 1,
        isFree: false,
        showOnlyInBundle:true
      }

      let productGetAllRequest = new ProductGetAllRequest(_this);
      productGetAllRequest.setParams(getProductData)
      await productGetAllRequest.fetch(function (content) {
        _this.products = content.products;
        _this.totalCounts = content.productsCount;
        _this.overlay = false;
      }, function (content) {
        console.log(content)
        _this.overlay = false;
      });
    },
    async removeItem() {
      let _this = this;
      _this.overlay = true;

      let data ={
        bundleId:_this.productId,
        productId: _this.deleteItem
      }

      let bundleRemoveProductFromBundleRequest = new BundleRemoveProductFromBundleRequest(_this);
      bundleRemoveProductFromBundleRequest.setParams(data);
      await bundleRemoveProductFromBundleRequest.fetch(function (content) {
        _this.overlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            icon: 'CheckIcon',
            variant: 'success',
            text: `حذف شد.`,
          },
        })
        _this.getPackageProducts();
      }, function (error) {
        console.log(error)
        _this.overlay = false;
      })
    },
    async addItem(id) {
      let _this = this;
      _this.overlay = true;

      let data ={
        bundleId:_this.productId,
        productIds: []
      }
      data.productIds.push(id)

      let bundleAddProductBundleRequest = new BundleAddProductBundleRequest(_this);
      bundleAddProductBundleRequest.setParams(data);
      await bundleAddProductBundleRequest.fetch(function (content) {
        _this.overlay = false;
        _this.$toast({
          component: ToastificationContent,
          position: 'bottom-center',
          props: {
            icon: 'CheckIcon',
            variant: 'success',
            text: `اضافه شد.`,
          },
        })
        _this.getPackageProducts();
      }, function (error) {
        console.log(error)
        _this.overlay = false;
      })
    },
    makePrettyPrice(param) {
      return Helper.prettyPrice(param, 0)
    },
    createJalaliDate(param) {
      return new Date(param).toLocaleDateString("fa-IR",);
    },
  },
  watch: {
    perPage: function (nv, ov) {
      this.getProducts(nv, this.currentPage, this.searchCommand);
    },
    currentPage: function (nv, ov) {
      this.getProducts(this.perPage, nv, this.searchCommand);
    },
    searchCommand: function (nv, ov) {
      this.getProducts(this.perPage, this.currentPage, nv)
    },
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BPagination,
    BOverlay,
    BModal,
    vSelect
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
